<template>
    <list-base-template
        :items='items'
        event='thread'
        :create='false'
        :errors='this.errors'
        v-on:paginate='getResults()'>

        <template v-slot:header>
            <h2 class="h4 p-2 m-0" v-if='quickFilters.unassigned == false && quickFilters.assigned == false && quickFilters.mine == false && quickFilters.closed == false && quickFilters.advanced == false && quickFilters.waiting == false' >All {{ getItemCount() }}</h2>
            <h2 class="h4 p-2 m-0" v-else-if='quickFilters.unassigned == true'>{{$t('translations.new')}} {{ getItemCount() }}</h2>
            <h2 class="h4 p-2 m-0" v-else-if='quickFilters.assigned == true'>{{$t('translations.assigned')}} {{ getItemCount() }}</h2>
            <h2 class="h4 p-2 m-0" v-else-if='quickFilters.mine == true'>{{$t('translations.mine')}} {{ getItemCount() }}</h2>
            <h2 class="h4 p-2 m-0" v-else-if='quickFilters.closed == true'>{{$t('translations.completed')}} {{ getItemCount() }}</h2>
            <h2 class="h4 p-2 m-0" v-else-if='quickFilters.waiting == true'>{{$t('translations.waiting')}} {{ getItemCount() }}</h2>
            <h2 class="h4 p-2 m-0" v-else-if='quickFilters.advanced == true'>{{$t('translations.filtered')}} {{ getItemCount() }}</h2>
            <h2 class="h4 p-2 m-0" v-else>{{ $t("translations." + title)}} {{ getItemCount() }}</h2>
        </template>   

        <template v-slot:quick_filters>
            <div class="filter-container-wrap d-flex">
                <button :title="$t('translations.new')" v-on:click.prevent='toggleFilter("unassigned")' :aria-pressed='quickFilters["unassigned"]' :class='"btn btn-unassigned" + (quickFilters["unassigned"] ? " active" : "")'>
                    <span v-if='unassignedUnreadRequestCount' :title='"" + unassignedUnreadRequestCount + ""' class="btn-alert-dot"></span>
                </button>
                <button :title="$t('translations.assigned')" v-on:click.prevent='toggleFilter("assigned")' :aria-pressed='quickFilters["assigned"]' :class='"btn btn-assigned" + (quickFilters["assigned"] ? " active" : "")'>
                    <!-- <span v-if='assignedUnreadRequestCount' :title='"" + assignedUnreadRequestCount + ""' class="btn-alert-dot"></span> -->
                </button>
                <button :title="$t('translations.assigned_to_me_or_my_groups')" v-on:click.prevent='toggleFilter("mine")' :aria-pressed='quickFilters["mine"]' :class='"btn btn-mine" + (quickFilters["mine"] ? " active" : "")'>
                    <span v-if='assignedToMeUnreadRequestCount' :title='"" + assignedToMeUnreadRequestCount + ""' class="btn-alert-dot"></span>
                </button>
                <!-- <button title="Waiting" v-on:click.prevent='toggleFilter("waiting")' :aria-pressed='quickFilters["waiting"]' :class='"btn btn-waiting" + (quickFilters["waiting"] ? " active" : "")'></button> -->
                <button :title="show_all_waiting ? autobrand('translations.waiting_for_patient') : autobrand('translations.waiting_for_patient_assigned_to_me_or_my_groups')" v-on:click.prevent='toggleFilter("waiting")' :aria-pressed='quickFilters["waiting"]' :class='"btn btn-waiting" + (quickFilters["waiting"] ? " active" : "")'>
                    
                </button>
                <button :title="$t('translations.completed')" v-on:click.prevent='toggleFilter("closed")' :aria-pressed='quickFilters["closed"]' :class='"btn btn-complete" + (quickFilters["closed"] ? " active" : "")'></button>
                <button :title="$t('translations.advanced_search')" v-on:click.prevent='showFilter();' :aria-pressed='quickFilters["advanced"]' :class='"btn btn-advanced" + (quickFilters["advanced"] ? " active" : "")'></button>
            </div>
        </template>

        <template v-slot:site_select>
            <template>
                <div class='d-flex flex-row-reverse align-items-center pb-1 justify-content-end flex-wrap'>
                    <div v-if='$root.provider.site.length > 1 || $root.provider.provider_provider_xref.length' class='d-flex align-items-baseline col-xl-12 col-lg-24 pr-1 pl-0 ml-auto'>
                        <!-- <b-dropdown text="Block Level Dropdown" block variant="primary" class="m-2">
                            <b-dropdown-item href="#">Action</b-dropdown-item>
                            <b-dropdown-item href="#">Another action</b-dropdown-item>
                            <b-dropdown-item href="#">Something else here</b-dropdown-item>
                        </b-dropdown> -->
  
                        <label class="site-select-label pr-1 pl-2 m-0">{{ $t('translations.source')}}:</label>
                        <b-form-select v-model='source_id' size="sm" class='invisible-select pl-1'>
                            <option value=''>{{$t('translations.all')}}</option>
                            <optgroup v-if='$root.provider.site.length > 1' :label="$t('translations.site')">
                                <option v-for='site in $root.provider.site' :key='`site_${site.id}`' :value='`site_${site.id}`'>{{site.name}}</option>
                            </optgroup>
                            <optgroup v-if='$root.provider.provider_provider_xref.length' :label="$t('translations.provider')">
                                <option v-for='provider in sortByValue($root.provider.provider_provider_xref, "name", "relation")' :key='`provider_${provider.relation.id}`' :value='`provider_${provider.relation.id}`'>{{provider.relation.name}}</option>
                            </optgroup>
                        </b-form-select>
                    </div>
                     <button v-if='quickFilters && (quickFilters["advanced"] == true || quickFilters["closed"] == true)' 
                            type="button" 
                            class="ml-2 btn-sm btn-light btn-refresh" v-on:click='getResults()'>
                        <span class="sr-only">Refresh</span>
                    </button>
                    <b-form-checkbox 
                            v-if='quickFilters && (quickFilters["waiting"] == true)' 
                            v-model="show_all_waiting" 
                            name="show_all_waiting" 
                            class='ml-2' 
                            switch>
                            
                        {{ $t("translations.show_all_waiting") }}
                    </b-form-checkbox>
                    <div class="ml-2 dropdown d-inline-block" v-if='isCurrentRequestFilter()'>
                        <button class="btn btn-secondary btn-round btn-sm" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class='fa fa-sm fa-tags'></i>
                        </button>
                        <div style='width: 200px' class="p-2 dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <autocomplete class='align-self-stretch form-control'
                                        v-model='tag'
                                        ref='ac'
                                        :source="[untagged_tag].concat($root.lookup.tags)"
                                        @clear='tag = null'
                                        :resultsDisplay='tagResultDisplay'
                                        @selected='setDisplayValue'
                                        @close='setDisplayValue'
                                        >
                                </autocomplete>
                        </div>
                    </div>
                    
                </div>
            </template>
        </template>

        <template v-slot:filter>
            <list-filter 
                v-on:apply='toggleFilter("advanced"); getResults(1)' 
                :expanded='true' 
                :key='event' 
                ref="listFilter" 
                :modalid='modalid'></list-filter>
        </template>

        <template v-slot:current-filter>
            <div v-if='$refs.listFilter || user_filter || created_by_user_filter || assigned_filter || assigned_group_filter'>
                <p v-if='$refs.listFilter && $refs.listFilter.$refs.search.value' class='search-lozenge badge badge-primary badge-pill'>
                    {{$refs.listFilter.$refs.search.value}}
                    <a v-on:click.prevent='$refs.listFilter.$refs.search.value = ""; getResults(1);' href="#">&times;</a>
                </p>
                <template v-for='(filter, index) in $refs.listFilter.appliedFilters'>
                    <p :key='index' v-if='$refs.listFilter.filterHasValue(filter)' class='search-lozenge badge badge-primary badge-pill'>
                        {{$refs.listFilter.getFilterDefinition(filter)}}
                        <a v-on:click.prevent='$refs.listFilter.appliedFilters.length > 1 ? $refs.listFilter.removeFilterByIndex(index) : $refs.listFilter.clearFilters();$refs.listFilter.applyFilters()' href="#">&times;</a>
                    </p>
                </template>
                <p v-if='user_filter' class='search-lozenge badge badge-primary badge-pill'>
                    User: {{formatName(user_filter)}}
                    <a v-on:click.prevent='user_filter = null' href="#">&times;</a>
                </p>
                <p v-if='created_by_user_filter' class='search-lozenge badge badge-primary badge-pill'>
                    Created by: {{formatName(created_by_user_filter)}}
                    <a v-on:click.prevent='created_by_user_filter = null' href="#">&times;</a>
                </p>
                <p v-if='assigned_filter' class='search-lozenge badge badge-primary badge-pill'>
                    Assigned to: {{formatName(assigned_filter)}}
                    <a v-on:click.prevent='assigned_filter = null' href="#">&times;</a>
                </p>
                <p v-if='assigned_group_filter' class='search-lozenge badge badge-primary badge-pill'>
                    Assigned to: {{assigned_group_filter.name}}
                    <a v-on:click.prevent='assigned_group_filter = null' href="#">&times;</a>
                </p>
                <div :key='tag.tag_id' v-for='(tag, index) in tag_filter' class='search-lozenge badge badge-primary badge-pill' :style="{'background-color': getTagLocal(tag.tag_id).colour}">
                    <i :class='"pr-1 fa fa-lg fa-" + getTagLocal(tag.tag_id).icon' /> {{ getTagLocal(tag.tag_id).name }}
                    <a v-on:click.prevent='deleteTag(index)' href="#">&times;</a>
                </div>
            </div>
            
        </template>

        <!-- SLOT: LIST -->
        <template v-slot:list>
            <ul class='list list-thread'>
                <!-- MAIN RENDER LOOP FOR THE REQUESTS -->
                <template v-for="item in items.data">
                    <template v-if='matchesFilter(item)'>
                        <thread :key='item.id' :item='item'
                            v-on:created-by-user-filter='setCreatedByUserFilter($event)'
                            v-on:user-filter='setUserFilter($event)'></thread>
                    </template>
                </template>
            </ul>
            <div v-if='environment_settings.MIX_ENABLE_ARCHIVE && !archive && quickFilters && items.next_page_url == null && (quickFilters["advanced"] == true || quickFilters["closed"] == true)' class="text-center">
                <button type='button' class='btn btn-primary' v-on:click='enableArchive()'>
                    {{ autobrand('translations.continue_search_in_archive') }}
                </button>
            </div>
        </template>

        <template v-slot:sort>
            <select v-model='sort' v-on:change='setSort' class="form-control-sm btn-sort__date small col">
                <option v-bind:value='{field: "created_at", dir: "asc"}'>{{$t('translations.oldest_on_top')}}</option>
                <option v-bind:value='{field: "created_at", dir: "desc"}'>{{$t('translations.newest_on_top')}}</option>
            </select>
        </template>

        <template v-slot:perpage>
            <div v-if='items.current_page' class="align-self-center mr-1">
                <b-form-select class="form-control w-auto per-page-select" v-model='per_page' v-on:change='changePerPage()'>
                    <!-- <option>2</option> -->
                    <option>10</option>
                    <option>20</option>
                    <option>50</option>
                </b-form-select>
            </div>
        </template>

        <template v-slot:selectedcontent>
            <router-view 
                v-on:reopen='getResults()' 
                v-on:delete='getResults()' 
                v-on:viewNext='viewNext()' 
                ref='content2' 
                name='content2' 
                :key="$route.fullPath">
            </router-view>
        </template>
    </list-base-template>
</template>

<script>
	export default {
        extends: app.base.listBase,
		props: [
		],
		data: function() {
			return {
                modalid: "thread-filter-modal",
                event: "thread",
                model: "thread",
                title: "requests",
                path: 'threads',
                route: '/api/v1/threads',
                hasArchive: true,
                user_filter: null,
                created_by_user_filter: null,
                assigned_filter: null,
                assigned_group_filter: null,
                show_all_waiting: false,
                tag_filter: [],
                tag: null,
                monitor_root_request_updates: true,
                untagged_tag: {colour: '#a0a0a0', icon: 'circle-notch', id: -1, name: this.autobrand('translations.untagged_requests')},
            };
        },
        watch: {
            show_all_waiting(value) {
				this.setSetting("thread_show_all_waiting", value);
            },
        },
        computed: {
            unassignedRequestCount() {
                return this.$root.requests.filter(obj => {return !obj.closed_at && obj.thread_provider && !obj.thread_provider.waiting_until && !obj.thread_provider.assigned_user_id && !obj.thread_provider.assigned_group_id}).length;
            },
            assignedRequestCount() {
                return this.$root.requests.filter(obj => {return !obj.closed_at && obj.thread_provider && !obj.thread_provider.waiting_until && (obj.thread_provider.assigned_user_id || obj.thread_provider.assigned_group_id)}).length;
            },
            assignedToMeRequestCount() {
                return this.$root.requests.filter(obj => {return !obj.closed_at && obj.thread_provider && !obj.thread_provider.waiting_until && (this.is_assignedToMe(obj) || this.is_assignedToMyGroups(obj))}).length;
            },
            unassignedUnreadRequestCount() {
                return this.$root.requests.filter(obj => {
                    return this.is_current(obj)
                            && !obj.thread_provider.assigned_user_id 
                            && !obj.thread_provider.assigned_group_id
                            && this.new_message(obj)
                }).length;
            },
            assignedUnreadRequestCount() {
                return this.$root.requests.filter(obj => {
                    return this.is_current(obj)
                            && (obj.thread_provider.assigned_user_id || obj.thread_provider.assigned_group_id)
                            && this.new_message(obj)}).length;
            },
            assignedToMeUnreadRequestCount() {
                return this.$root.requests.filter(obj => {
                    return this.is_current(obj)
                            && (this.is_assignedToMe(obj) || this.is_assignedToMyGroups(obj))
                            && this.new_message(obj)}).length;
            },
        },
		methods : {
            is_current(item) {
                return !item.closed_at && item.thread_provider && !item.thread_provider.waiting_until;
            },
            initSettings() {
                this._initSettings();
                this.show_all_waiting = this.getSetting("thread_show_all_waiting");
            },
            initData() {
				this.setLoading(true);
                this.errors = [];

                if(Object.keys(this.quickFilters).length == 0) {
                    this.resetQuickFilters();
                }
                //this.quickFilters["assigned"] = false;
                
                
                if(this.$root.lookup.relatedData[this.route]) {
                    this.processRelatedData(this.$root.lookup.relatedData[this.route]);
                }
                else {
                    axios.get(this.route + '/relatedData').then((res) => {
                        this.$root.lookup.relatedData[this.route] = res.data;
                        this.processRelatedData(res.data);
                    }).catch(error => {
                        this.setLoading(false);
                        this.handleError(error, "load");
                    });
                }
            },
            getItemCount() {
                if(this.items && this.items.data) {
                    if(this.quickFilters['advanced'] == true || this.quickFilters['closed'] == true) {
                        return "";
                        //return this.items.total;
                    }
                    else {
                        return "[" + this.items.data.filter(item => {
                            return this.matchesFilter(item);
                        }).length + "]";
                        //return "--";
                    }
                }
                return "";
            },
            toggleFilter(filter) {
                if(this.$route.path != "/" + this.event + "-list") {
                    this.$router.push({path: "/" + this.event + "-list"});
                }
				for(var index in this.quickFilters) {
					if(index == filter) {
						//this.quickFilters[index] = !this.quickFilters[index];
						this.quickFilters[index] = true;
					}
					else {
						this.quickFilters[index] = false;
					}
                }
                // Reset the archive flag when we change filters.
                this.archive = false;
				if(filter !== "advanced") {
					this.$refs.listFilter.clearFilters(null);
					this.$refs.listFilter.appliedFilters = [];
					this.getResults(1);
				}
                if(filter == 'advanced' || filter == 'closed') {
                    this.created_by_user_filter = null;
                    this.user_filter = null;
                    this.assigned_filter = null;
                    this.assigned_group_filter = null;
                    this.tag_filter = [];
                }
                if(filter != 'assigned' && filter != 'waiting') {
                    this.assigned_filter = null;
                    this.assigned_group_filter = null;
                }
                
            },
            matchesFilter(item) {
                if(this.quickFilters['advanced'] == true || this.quickFilters['closed'] == true) {
                    return true;
                }
                else {
                    if(this.user_filter && item.user.id != this.user_filter.id) {
                        return false;
                    }
                    if(this.created_by_user_filter && item.created_by_user.id != this.created_by_user_filter.id) {
                        return false;
                    }
                    if(this.assigned_filter && item.thread_provider && item.thread_provider.assigned_user_id != this.assigned_filter.id) {
                        return false;
                    }
                    if(this.assigned_group_filter && item.thread_provider && item.thread_provider.assigned_group_id != this.assigned_group_filter.id) {
                        return false;
                    }
                    if(this.source_provider_id
                            && (item.originating_provider_id != this.source_provider_id)
                            && (item.last_transferred_from_provider_id != this.source_provider_id)
                            && (item.owner_provider_id != this.source_provider_id)
                            ) {
                        return false;
                    }
                    
                    if(this.tag_filter.length) {
                        let hasTag = false;
                        this.tag_filter.forEach(tag_filter => {
                            if(this.getTags(item).find(tag => {
                                return tag.tag_id == tag_filter.tag_id;
                            })) {
                                hasTag = true;
                            }
                            if(tag_filter.tag_id == this.untagged_tag.id
                                    && (!Array.isArray(item.thread_tag) || !item.thread_tag.length)) {
                                hasTag = true;
                            }
                        })
                        if(!hasTag) {
                            return false;
                        }
                    }
                    if(this.site_id && item.user.provider.site_id != this.site_id) {
                        return false;
                    }
                    if(this.quickFilters['unassigned'] && this.is_unassigned(item) && !this.is_waiting(item) && !this.is_closed(item)) {
                        return true;
                    }
                    if(this.quickFilters['assigned'] && this.is_assigned(item) && !this.is_waiting(item) && !this.is_closed(item)) {
                        return true;
                    }
                    if(this.quickFilters['mine']  && !this.is_waiting(item) && !this.is_closed(item)
                            && (this.is_assignedToMe(item) || this.is_assignedToMyGroups(item))) {
                        return true;
                    }
                    if(this.quickFilters['waiting'] && this.is_waiting(item) && !this.is_closed(item)
                            && (this.show_all_waiting || this.is_assignedToMe(item) || this.is_assignedToMyGroups(item))
                            ) {
                        return true;
                    }
                    if(this.quickFilters['closed'] && this.is_closed(item)) {
                        return true;
                    }
                    
                }
                return false;
            },
            getResults(page, showLoading, prevent) {
                console.log(this.route);
                if(!this.appActive()) {
                    this.stale = true;
                    return Promise.reject("Application is not active. Data set to 'stale'. Will update when active.");
                }
                if (typeof showLoading === 'undefined') {
					showLoading = true;
				}

				if(showLoading) {
					this.setLoading(true);
				}

				if (typeof page !== 'undefined') {
					this.items.current_page = page;
				}

				var search = (this.$refs && this.$refs.listFilter ? this.$refs.listFilter.$refs.search.value : "");

				var filter = encodeURIComponent(JSON.stringify(this.quickFilters));

                if(this.quickFilters['assigned'] == false &&
                        this.quickFilters['unassigned'] == false &&
                        this.quickFilters['mine'] == false &&
                        this.quickFilters['waiting'] == false &&
                        this.quickFilters['closed'] == false &&
                        this.quickFilters['advanced'] == false) {

                    var defaultFilter = {};
                    defaultFilter['unassigned'] = true;
                    defaultFilter['mine'] = true;

                    filter = encodeURIComponent(JSON.stringify(defaultFilter));
                }

                if(this.quickFilters['advanced'] == true && this.$refs && this.$refs.listFilter && this.$refs.listFilter.filterShown) {
                    var singleFields = this.$refs.listFilter.appliedFilters.filter(obj => {
                        return (obj.field == "id" /* || obj.field == "user.surname" || obj.field == "user.dob" */) && obj.value;
                    });
                    if(singleFields.length) {
                        search = encodeURIComponent(JSON.stringify(singleFields));
                    }
                    else {
                        // if(this.site_id) {
                        //     search = encodeURIComponent(JSON.stringify(this.$refs.listFilter.appliedFilters.concat([{"field":"site_id","type":"=","value":this.site_id}])));
                        // }
                        // else {
                        search = encodeURIComponent(JSON.stringify(this.$refs.listFilter.appliedFilters));
                        // }
                    }
                    // var overrideFilters = JSON.parse(JSON.stringify(this.quickFilters));
                    // overrideFilters['closed'] = true;

                    filter = "";
                }
            
                var params = {sort: this.sort};
                if(this.quickFilters['advanced'] == true || this.quickFilters['closed'] == true) {
                    this.items.data = [];
                    var site_filter = this.site_id ? `site_id=${this.site_id}&` : "";
                    var source_provider_filter = this.source_provider_id ? `source_provider_id=${this.source_provider_id}&` : "";
                    return axios.get(this.route + '?' + site_filter + source_provider_filter + 'search=' + search + '&filter=' + filter + '&page=' + this.items.current_page + '&p=' + this.per_page  + (this.archive ? '&archive=1' : ''), {params: params}).then((res) => {
                        //console.log("current_page: " + res.data.current_page);
                        //console.log("last_page: " + res.data.last_page);
                        if(res.data.current_page > res.data.last_page && prevent !== true) {
                            console.log("Re-searching with page in range.");
                            this.items = {};
                            this.getResults(res.data.last_page, showLoading, true)
                        }
                        else {
                            this.setLoading(false);
                            this.items = res.data;
                        }
                    }).catch((error) => {
                        if(showLoading) {
                            this.setLoading(false);
                        }
                        this.handleError(error, "load");
                        //this.$router.push({path: "/" + this.event + "-list"});
                    });
                }
                else {
                    this.setLoading(false);
                    this.items.data = this.$root.requests;
                    //this.sortRequests();
                    this.items.current_page = null;
                }
			},
            haveIncomingFilterParameters() {
                if(this.$route.params.assigned_to || this.$route.params.assigned_filter || this.$route.params.assigned_group_filter) {
                    return true;
                }
                return false;
            },
            setFiltersFromRouteParams() {
                if(this.haveIncomingFilterParameters()) {
                    if(this.$route.params.assigned_to) {
                        this.site_id = "";
                        this.$refs.listFilter.setFilter("assigned_to", "=", this.$route.params.assigned_to, false);
                        this.$refs.listFilter.setFilter("secondary_status", "=", this.$route.params.secondary_status, true);
                        delete(this.$route.params.assigned_to);
                        delete(this.$route.params.secondary_status);
                    }
                    else if(this.$route.params.assigned_filter) {
                        //this.site_id = this.$route.params.site_id;
                        this.site_id = "";
                        this.show_all_waiting = true;
                        this.assigned_filter = this.copyNonReactive(this.$route.params.assigned_filter);
                        delete(this.$route.params.assigned_filter);
                        delete(this.$route.params.site_id);
                        this.toggleFilter("assigned");
                        this.setLoading(false);
                    }
                    else if(this.$route.params.assigned_group_filter) {
                        //this.site_id = this.$route.params.site_id;
                        this.site_id = "";
                        this.show_all_waiting = true;
                        this.assigned_group_filter = this.copyNonReactive(this.$route.params.assigned_group_filter);
                        delete(this.$route.params.assigned_group_filter);
                        delete(this.$route.params.site_id);
                        this.toggleFilter("assigned");
                        this.setLoading(false);
                    }
                }
            },
			is_assigned(item) {
				if(item.thread_provider 
                        && (
                            item.thread_provider.assigned_user_id 
                            || item.thread_provider.assigned_group_id 
                            || (
                                // We are the originator
                                item.originating_provider_id == this.$root.provider.id 
                                // and we've transferred ownership
                                && item.owner_provider_id != this.$root.provider.id))) {
					return true
				}
				return false;
			},
			is_unassigned(item) {
				if(item.thread_provider 
                        && (
                            !item.thread_provider.assigned_user_id 
                            && !item.thread_provider.assigned_group_id
                            && !(
                                // We are the originator
                                item.originating_provider_id == this.$root.provider.id 
                                // and we've transferred ownership
                                && item.owner_provider_id != this.$root.provider.id))) {
					return true
				}
				return false;
			},
			is_assignedToMe(item) {
				if(item.thread_provider && item.thread_provider.assigned_user_id == this.$root.user.id) {
					return true
				}

				return false;
            },
            is_waiting(item) {
				if(item.thread_provider && item.thread_provider.waiting_until) {
					return true
				}

				return false;
            },
            is_assignedToMyGroups(item) {
				if(item.thread_provider && item.thread_provider.assigned_group_id) {
					//alert("item.thread_provider.assigned_group_id:" + item.thread_provider.assigned_group_id);
					var val = this.$root.user.user_group.filter(obj => {
						//alert("obj.user_group_id: " + obj.user_group_id);
						//console.log("Comparing: " + "item.thread_provider.assigned_group_id:" + item.thread_provider.assigned_group_id + " to " + "obj.user_group_id: " + obj.user_group_id);
						return item.thread_provider.assigned_group_id == obj.user_group_id;
					});
					return val.length;
				}
				return false;
            },
            is_archived(item) {
				if(item.archived) {
					return true
				}
				return false;
			},
            // This is more general than new_message. No additional checks for assignment, or user type.
            is_unread(item) {
                if(!item.user_thread_read_status) {
                    return true;
                }
                if(item.latest_message != null && typeof item.latest_message == "object" && item.latest_message.created_at > item.user_thread_read_status.read_at) {
                    return true;
                }
                return false;
            },
            // This checks assignment and user type and then calls is_unread. Used more generally.
			new_message(item) {
				if(this.is_patient() || this.is_assignedToMe(item) || this.is_assignedToMyGroups(item) || this.is_unassigned(item)) {
					return this.is_unread(item);
				}
				return false;
			},

			is_closed(item) {
				if(item.closed_at) {
					return true
				}
				return false;
			},
			staff_has_responded(item) {
				if(item.latest_message_to_patient) {
					return true;
				}
				return false;
			},
			has_unread_response(item) {
                // if(item.id == 19921) {
                //     console.log(item.latest_unread_message_to_patient, !this.is_patient(item.created_by_user), item.latest_unread_message_to_creator);
                //     console.log(item.latest_unread_message_to_patient && (!this.is_patient(item.created_by_user) || item.latest_unread_message_to_creator));
                // }
                if(item.latest_unread_message_to_patient && (!this.is_patient(item.created_by_user) || item.latest_unread_message_to_creator)) {
					return true;
				}
				return false;
			},
			patient_read_all(item) {
				if(this.staff_has_responded(item) && !this.has_unread_response(item)) {
					return true;
				}
				return false;
			},
			assignee_name(item) {
				if(item.thread_provider && item.thread_provider.assigned_user) {
					return item.thread_provider.assigned_user.surname + ", " + item.thread_provider.assigned_user.forenames;
				}
				else if(item.thread_provider && item.thread_provider.assigned_group) {
					return item.thread_provider.assigned_group.name;
				}
				return this.$t('translations.unassigned');

			},
			updateMessage: function () {
				this.message = this.$t('translations.updated')
				console.log(this.$el.textContent) // => 'not updated'
				this.$nextTick(function () {
					console.log(this.$el.textContent) // => 'updated'
				})
			},
			getPriorityClass(item) {
				if(this.is_staff()) {
					switch(item.thread_provider.priority) {
						case -10: return "lower"; break;
						case 0: return "routine"; break;
						case 5: return "visit"; break;
						case 10: return "urgent"; break;
						case 20: return "emergency"; break;
					}
				}
            },
            
            isCurrentRequestFilter() {
                return this.quickFilters['unassigned'] 
                    || this.quickFilters['assigned']
                    || this.quickFilters['mine']
                    || this.quickFilters['waiting'];
            },
            getTags(item) {
                if(item.thread_tag || (item.user && item.user.user_tag)) {
                    var thread_tag = item.thread_tag ? item.thread_tag : [];
                    var user_tag = (item.user && item.user.user_tag) ? item.user.user_tag : [];
                    
                    return [...new Map(thread_tag.concat(user_tag).map(obj => [obj["tag_id"], obj])).values()];
                }
                
            },
            getTagLocal(id) {
                if(id == -1) {
                    return this.untagged_tag;
                }
                return this.getTag(id);
            },
            setDisplayValue() {
                Vue.nextTick(() => {
                    if(this.$refs.ac.value) {
                        var tag = [this.untagged_tag].concat(this.$root.lookup.tags).find(obj => {return obj.id == this.$refs.ac.value});
                        if(tag) {
                            this.addTag(this.tag);
                        }
                        this.tag = null;
                        this.$refs.ac.clear();
                    }
                });
            },
            addTag(tag) {
                if(!this.tag_filter.find(obj => {return obj.tag_id == tag})) {
                    this.tag_filter.push({tag_id: tag});
                }                
            },
            deleteTag(index) {
                this.tag_filter.splice(index, 1); 
            },
            setSort() {
                if(!(this.quickFilters['advanced'] == true || this.quickFilters['closed'] == true)) {
                    this.$root.requestSort = this.sort;
                    this.$root.sortRequests();
                }
                this.getResults();
            },
            setCreatedByUserFilter(user) {
                this.created_by_user_filter = user;
                this.show_all_waiting = true;
            },
            setUserFilter(user) {
                this.user_filter = user;
                this.show_all_waiting = true;
            },
            
            
		}
    }
</script>
